module.exports = __webpack_public_path__ + "img/jpeg.49ac18ac.png";